import { ServiceTimeUnit } from './ServiceTimeLeftForFirstAvailableDate.js';

class ServiceTimeLeftForFirstAvailableDateMapper {
  static createFromResponse(response) {
    return {
      unit: ServiceTimeUnit[response.time_unit],
      value: response.time_value
    };
  }
}

export { ServiceTimeLeftForFirstAvailableDateMapper };
//# sourceMappingURL=ServiceTimeLeftForFirstAvailableDateMapper.js.map
